import { createElement, forwardRef } from "react";
import { clsx } from "clsx";

import { toPx } from "~/utils/components";

import "./Box.css";

import type { CSSProperties, ReactNode } from "react";

export interface BoxProps {
  as?:
    | "div"
    | "span"
    | "main"
    | "article"
    | "section"
    | "form"
    | "label"
    | "header"
    | "li"
    | "a";
  align?: "stretch" | "center" | "start" | "end";
  children?: ReactNode;
  className?: string;
  direction?: "column" | "row";
  gap?: 0 | 1 | 2 | 4 | 6 | 8 | 10 | 12 | 14 | 16 | 20 | string;
  justify?: "stretch" | "center" | "start" | "end" | "space-between";
  style?: CSSProperties;
}

export const Box = forwardRef<HTMLElement, BoxProps>(function BoxImpl(
  {
    as = "div",
    align,
    className,
    direction,
    gap,
    justify,
    style = {},
    children,
  },
  ref,
) {
  const customProperties = {
    "--box-align": align,
    "--box-direction": direction,
    "--box-gap": typeof gap === "number" ? toPx(gap) : gap,
    "--box-justify": justify,
  } as CSSProperties;

  return createElement(
    as,
    {
      ref,
      className: clsx("Box", className),
      style: { ...customProperties, ...style },
    },
    children,
  );
});
